import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import styled from 'styled-components';
import ConfirmModal from '../../../components/modal/ConfirmModal';
import StoreController, {
  HotelIntroCardType,
  HotelIntroType,
  HotelIntroVoucherType,
} from '../../../controller/StoreController';
import UtilController from '../../../controller/UtilController';
import { AuthContext } from '../../../navigation/AuthProvider';
import { DndProvider, DropTargetMonitor, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import toast from 'react-hot-toast';
import DatePicker, { registerLocale } from 'react-datepicker';
import { ko } from 'date-fns/locale';
import moment from 'moment-timezone';

registerLocale('ko', ko);

interface DraggableItemProps {
  item: HotelIntroCardType;
  index: number;
  moveItem: (fromIndex: number, toIndex: number) => void;
  uploadContentImage: any;
  guideContentLang: any;
  onChange_guideInfoLang: any;
  deleteContent: any;
  getLangToContent: any;
  onChange_guideContent: any;
}

const RenderContentItem = ({
  item,
  index,
  moveItem,
  uploadContentImage,
  guideContentLang,
  onChange_guideInfoLang,
  deleteContent,
  getLangToContent,
  onChange_guideContent,
}: DraggableItemProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(index + 1);

  const [, drag] = useDrag({
    type: 'ITEM',
    item: { item, index },
  });

  const [, drop] = useDrop({
    accept: 'ITEM',
    hover: (item: { index: number }, monitor: DropTargetMonitor) => {
      if (item.index !== index) {
        moveItem(item.index, index);
        item.index = index;
      }
    },
  });

  return (
    <>
      <input
        className="point"
        ref={(node) => drag(drop(node))}
        value={selectedIndex}
        autoFocus={false}
        onChange={(e) => {
          setSelectedIndex(Number(e.target.value));
        }}
        onBlur={() => {
          moveItem(index, selectedIndex - 1);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            moveItem(index, selectedIndex - 1);
          }
        }}
      />
      {item.content_type === 0 ? (
        <div className="imageList logo">
          <input
            id={`contentImg_${index}`}
            type="file"
            name="photo"
            accept="image/*"
            autoFocus={false}
            onChange={(e) => uploadContentImage(e, index)}
          />
          {item.url !== null && item.url !== '' ? (
            <div className="previewImageWrap logo">
              <img className="previewImg" src={item.url} alt="img" />
            </div>
          ) : (
            <label className="photoBox logo" htmlFor={`contentImg_${index}`}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_photo.svg`} alt="ic" />
              <h5>이미지 추가</h5>
              <div className="imageDeleteButton">
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_close_white.svg`}
                  onClick={() => deleteContent(index)}
                  alt="ic"
                />
              </div>
            </label>
          )}
          {item.url !== null && item.url && (
            <>
              <label className="imageButton edit" htmlFor={`contentImg_${index}`}>
                수정
              </label>
              <button className="imageButton delete" onClick={() => deleteContent(index)}>
                삭제
              </button>
            </>
          )}
        </div>
      ) : (
        item.content_type === 1 && (
          <div className="storeInfoWrap" key={index}>
            <div className="imageDeleteButton">
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_close_white.svg`}
                onClick={() => deleteContent(index)}
                alt="ic"
              />
            </div>
            <div className="infoRow">
              <div>
                <button
                  className={`langButton ${guideContentLang[index] === 0 && 'active'}`}
                  onClick={() => onChange_guideInfoLang(index, 0)}>
                  한국어
                </button>
                <button
                  className={`langButton ${guideContentLang[index] === 1 && 'active'}`}
                  onClick={() => onChange_guideInfoLang(index, 1)}>
                  영어
                </button>
                <button
                  className={`langButton ${guideContentLang[index] === 2 && 'active'}`}
                  onClick={() => onChange_guideInfoLang(index, 2)}>
                  중국어
                </button>
                <button
                  className={`langButton ${guideContentLang[index] === 3 && 'active'}`}
                  onClick={() => onChange_guideInfoLang(index, 3)}>
                  일본어
                </button>
                <button
                  className={`langButton ${guideContentLang[index] === 4 && 'active'}`}
                  onClick={() => onChange_guideInfoLang(index, 4)}>
                  태국어
                </button>
                <button
                  className={`langButton ${guideContentLang[index] === 5 && 'active'}`}
                  onClick={() => onChange_guideInfoLang(index, 5)}>
                  스페인어
                </button>
                <button
                  className={`langButton ${guideContentLang[index] === 6 && 'active'}`}
                  onClick={() => onChange_guideInfoLang(index, 6)}>
                  프랑스어
                </button>
                <button
                  className={`langButton ${guideContentLang[index] === 7 && 'active'}`}
                  onClick={() => onChange_guideInfoLang(index, 7)}>
                  러시아어
                </button>
                <button
                  className={`langButton ${guideContentLang[index] === 8 && 'active'}`}
                  onClick={() => onChange_guideInfoLang(index, 8)}>
                  독일어
                </button>
              </div>
              <textarea
                placeholder="등록하고 싶은 내용을 작성해주세요."
                value={getLangToContent(index)!}
                onChange={(e) => onChange_guideContent(index, e)}
              />
            </div>
            {/* {hotelInfo.card_content.filter((item) => item.content_type === 1).length >
             1 && (
             <button
               className="imageButton delete bottom"
               onClick={() => deleteContent(index)}>
               삭제
             </button>
           )} */}
          </div>
        )
      )}
    </>
  );
};

const RecommendEdit = () => {
  const { userInfo } = useContext(AuthContext);

  const navigate = useNavigate();

  const { store_id, card_id } = useParams();

  const [hotelInfo, setHotelInfo] = useState<HotelIntroType>({
    title: '',
    title_en: '',
    title_ch: '',
    title_ja: '',
    title_th: '',
    title_es: '',
    title_fr: '',
    title_ru: '',
    title_de: '',
    card_type: 1,
    url: '',
    card_content: [],
    voucher_id: null,
  });

  const [guideTitleLang, setGuideTitleLang] = useState<number>(0);
  const [guideContentLang, setGuideContentLang] = useState<number[]>([]);

  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);

  const [isVoucher, setIsVoucher] = useState<boolean>(false);
  const [isEndDateInfinite, setIsEndDateInfinite] = useState<boolean>(false);
  const [endDate, setEndDate] = useState<Date>(new Date());

  const [voucherData, setVoucherData] = useState<HotelIntroVoucherType>({
    benefit: '',
    benefit_en: '',
    phone_number: '',
    address: '',
    address_en: '',
    store_name: '',
    store_name_en: '',
    map_link: '',
    end_date: null,
    comment: '',
    comment_en: '',
    comment_ch: '',
    comment_ja: '',
    comment_th: '',
    comment_es: '',
    comment_fr: '',
    comment_ru: '',
    comment_de: '',
  });
  const [voucherCommentLang, setVoucherCommentLang] = useState<number>(0);

  const getHotelIntroCard = async () => {
    try {
      const oParams = {
        store_id: store_id,
        card_id: Number(card_id),
      };

      const oRes = await StoreController.getHotelIntroCard(oParams);
      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getHotelIntroCard', oResponse);
        if (oResponse.data && oResponse.ok) {
          setHotelInfo(oResponse.data);
          setGuideContentLang(new Array(oResponse.data.card_content.length).fill(0));
          setIsVoucher(oResponse.data.voucher_id);
          if (oResponse.data.voucher_data) {
            setVoucherData(oResponse.data.voucher_data);
          }
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  const setHotelIntro = async () => {
    try {
      if (checkRequired()) {
        const hotelInfoTemp = hotelInfo;
        if (isVoucher) {
          const voucherDateTemp = voucherData;
          voucherDateTemp['end_date'] = !isEndDateInfinite
            ? moment(endDate).format('YYYY-MM-DD')
            : null;
          hotelInfoTemp['voucher_data'] = voucherDateTemp;
        }

        const oParams = {
          store_id: store_id,
          hotel_intro: hotelInfoTemp,
        };

        const oRes = await StoreController.setHotelIntro(oParams);
        if (oRes && oRes.data) {
          const oResponse = oRes.data;
          console.log('setHotelIntro', oResponse);
          if (oResponse.data && oResponse.ok) {
            toast.success('새로운 호텔소개를 등록했어요');
          }
        }
      } else {
        toast.error('필수 항목을 추가해주세요');
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  const editHotelIntro = async () => {
    try {
      if (checkRequired()) {
        const hotelInfoTemp = hotelInfo;
        if (isVoucher) {
          const voucherDateTemp = voucherData;
          voucherDateTemp['end_date'] = !isEndDateInfinite
            ? moment(endDate).format('YYYY-MM-DD')
            : null;
          hotelInfoTemp['voucher_data'] = voucherDateTemp;
        }

        const oParams = {
          store_id: store_id,
          hotel_intro: hotelInfoTemp,
        };

        const oRes = await StoreController.editHotelIntro(oParams);
        if (oRes && oRes.data) {
          const oResponse = oRes.data;
          console.log('editHotelIntro', oResponse);
          if (oResponse.data && oResponse.ok) {
            toast.success('호텔소개를 수정했어요');
          }
        }
      } else {
        toast.error('필수 항목을 추가해주세요');
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  const delHotelIntro = async () => {
    try {
      const oParams = {
        store_id: store_id,
        card_id: Number(card_id),
      };

      const oRes = await StoreController.delHotelIntro(oParams);
      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('delHotelIntro', oResponse);
        if (oResponse.data && oResponse.ok) {
          toast.success('소개를 삭제했어요');
          navigate(-1);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  // 이미지 등록
  const uploadLogoImage = async (e: any) => {
    console.log('files', e.target.files);
    let origin = e.target.files[0];
    if (origin !== undefined) {
      if (origin.type !== undefined && origin.type !== null) {
        if (origin.type === 'image/png' || origin.type === 'image/jpeg') {
          const formData = new FormData();
          formData.append('file', origin);
          const oRes = await UtilController.IntroLogoUploadImg(formData, userInfo.user_id);
          console.log('uploadLogoImage', oRes);
          if (oRes.data) {
            const oResponse = oRes.data;
            if (oResponse.ok && oResponse.data) {
              let introTemp = hotelInfo;
              introTemp.url = oResponse.data.url_path;
              introTemp.resize_path_l = oResponse.data.resize_path_l;
              introTemp.resize_path_m = oResponse.data.resize_path_m;
              introTemp.resize_path_s = oResponse.data.resize_path_s;

              setHotelInfo({ ...introTemp });
            } else {
              toast.error('파일 이름이 너무 길거나 형식에 맞지 않아요');
            }
          }
          return;
        }
      }
    }
  };

  const moveItem = (fromIndex: number, toIndex: number) => {
    if (toIndex < 1) toIndex = 0;
    else if (toIndex > hotelInfo.card_content.length - 1) toIndex = hotelInfo.card_content.length;
    const newItems = { ...hotelInfo };
    const [movedItem] = newItems.card_content.splice(fromIndex, 1);
    newItems.card_content.splice(toIndex, 0, movedItem);
    setHotelInfo({ ...newItems });
  };

  const uploadContentImage = async (e: any, index: number) => {
    // if (hotelInfo.card_content.filter((item) => item.content_type === 0).length < 3) {
    console.log('files', e.target.files);
    let origin = e.target.files[0];
    if (origin !== undefined) {
      if (origin.type !== undefined && origin.type !== null) {
        if (origin.type === 'image/png' || origin.type === 'image/jpeg') {
          const formData = new FormData();
          formData.append('file', origin);
          const oRes = await UtilController.IntroImageUploadImg(formData, userInfo.user_id);
          console.log('uploadContentImage', oRes);
          if (oRes.data) {
            const oResponse = oRes.data;
            if (oResponse.ok && oResponse.data) {
              let introTemp = hotelInfo;
              introTemp.card_content[index].url = oResponse.data.url_path;
              introTemp.card_content[index].resize_path_l = oResponse.data.resize_path_l;
              introTemp.card_content[index].resize_path_m = oResponse.data.resize_path_m;
              introTemp.card_content[index].resize_path_s = oResponse.data.resize_path_s;

              setHotelInfo({ ...introTemp });
            } else {
              toast.error('파일 이름이 너무 길거나 형식에 맞지 않아요');
            }
          }
          return;
        }
      }
    }
    // } else {
    //   toast.success('더 이상 사진을 등록할 수 없어요', 'error');
    // }
  };

  const addStoreInfo = (type: number) => {
    // if (hotelInfo.card_content.length < 3) {
    const cardContent = {
      content: null,
      content_en: null,
      content_ch: null,
      content_ja: null,
      content_th: null,
      content_es: null,
      content_fr: null,
      content_ru: null,
      content_de: null,
      content_type: type,
      url: null,
    };

    let introTemp = hotelInfo;
    introTemp.card_content.push(cardContent);
    setHotelInfo({ ...introTemp });
    setGuideContentLang([...guideContentLang, 0]);
    // }
  };

  const deleteContent = (index: number) => {
    let introTemp = hotelInfo;
    introTemp.card_content.splice(index, 1);
    setHotelInfo({ ...introTemp });
  };

  const getLangToTitle = () => {
    if (guideTitleLang === 1) return hotelInfo.title_en === null ? '' : hotelInfo.title_en;
    else if (guideTitleLang === 2) return hotelInfo.title_ch === null ? '' : hotelInfo.title_ch;
    else if (guideTitleLang === 3) return hotelInfo.title_ja === null ? '' : hotelInfo.title_ja;
    else if (guideTitleLang === 4) return hotelInfo.title_th === null ? '' : hotelInfo.title_th;
    else if (guideTitleLang === 5) return hotelInfo.title_es === null ? '' : hotelInfo.title_es;
    else if (guideTitleLang === 6) return hotelInfo.title_fr === null ? '' : hotelInfo.title_fr;
    else if (guideTitleLang === 7) return hotelInfo.title_ru === null ? '' : hotelInfo.title_ru;
    else if (guideTitleLang === 8) return hotelInfo.title_de === null ? '' : hotelInfo.title_de;
    else return hotelInfo.title === null ? '' : hotelInfo.title;
  };

  const getLangToContent = (index: number) => {
    if (hotelInfo.card_content.length > index) {
      if (guideContentLang[index] === 1)
        return hotelInfo.card_content[index].content_en === null
          ? ''
          : hotelInfo.card_content[index].content_en;
      else if (guideContentLang[index] === 2)
        return hotelInfo.card_content[index].content_ch === null
          ? ''
          : hotelInfo.card_content[index].content_ch;
      else if (guideContentLang[index] === 3)
        return hotelInfo.card_content[index].content_ja === null
          ? ''
          : hotelInfo.card_content[index].content_ja;
      else if (guideContentLang[index] === 4)
        return hotelInfo.card_content[index].content_th === null
          ? ''
          : hotelInfo.card_content[index].content_th;
      else if (guideContentLang[index] === 5)
        return hotelInfo.card_content[index].content_es === null
          ? ''
          : hotelInfo.card_content[index].content_es;
      else if (guideContentLang[index] === 6)
        return hotelInfo.card_content[index].content_fr === null
          ? ''
          : hotelInfo.card_content[index].content_fr;
      else if (guideContentLang[index] === 7)
        return hotelInfo.card_content[index].content_ru === null
          ? ''
          : hotelInfo.card_content[index].content_ru;
      else if (guideContentLang[index] === 8)
        return hotelInfo.card_content[index].content_de === null
          ? ''
          : hotelInfo.card_content[index].content_de;
      else
        return hotelInfo.card_content[index].content === null
          ? ''
          : hotelInfo.card_content[index].content;
    }
  };

  const getLangToComment = () => {
    if (voucherCommentLang === 1)
      return voucherData.comment_en === null ? '' : voucherData.comment_en;
    else if (voucherCommentLang === 2)
      return voucherData.comment_ch === null ? '' : voucherData.comment_ch;
    else if (voucherCommentLang === 3)
      return voucherData.comment_ja === null ? '' : voucherData.comment_ja;
    else if (voucherCommentLang === 4)
      return voucherData.comment_th === null ? '' : voucherData.comment_th;
    else if (voucherCommentLang === 5)
      return voucherData.comment_es === null ? '' : voucherData.comment_es;
    else if (voucherCommentLang === 6)
      return voucherData.comment_fr === null ? '' : voucherData.comment_fr;
    else if (voucherCommentLang === 7)
      return voucherData.comment_ru === null ? '' : voucherData.comment_ru;
    else if (voucherCommentLang === 8)
      return voucherData.comment_de === null ? '' : voucherData.comment_de;
    else return voucherData.comment === null ? '' : voucherData.comment;
  };

  const onChange_guideName = (event: any) => {
    let introTemp = hotelInfo;
    if (guideTitleLang === 0) introTemp.title = event.target.value;
    else if (guideTitleLang === 1) introTemp.title_en = event.target.value;
    else if (guideTitleLang === 2) introTemp.title_ch = event.target.value;
    else if (guideTitleLang === 3) introTemp.title_ja = event.target.value;
    else if (guideTitleLang === 4) introTemp.title_th = event.target.value;
    else if (guideTitleLang === 5) introTemp.title_es = event.target.value;
    else if (guideTitleLang === 6) introTemp.title_fr = event.target.value;
    else if (guideTitleLang === 7) introTemp.title_ru = event.target.value;
    else if (guideTitleLang === 8) introTemp.title_de = event.target.value;

    setHotelInfo({ ...introTemp });
  };

  const onChange_guideContent = (index: number, event: any) => {
    let introTemp = hotelInfo;
    if (hotelInfo.card_content.length > index) {
      if (guideContentLang[index] === 0) introTemp.card_content[index].content = event.target.value;
      else if (guideContentLang[index] === 1)
        introTemp.card_content[index].content_en = event.target.value;
      else if (guideContentLang[index] === 2)
        introTemp.card_content[index].content_ch = event.target.value;
      else if (guideContentLang[index] === 3)
        introTemp.card_content[index].content_ja = event.target.value;
      else if (guideContentLang[index] === 4)
        introTemp.card_content[index].content_th = event.target.value;
      else if (guideContentLang[index] === 5)
        introTemp.card_content[index].content_es = event.target.value;
      else if (guideContentLang[index] === 6)
        introTemp.card_content[index].content_fr = event.target.value;
      else if (guideContentLang[index] === 7)
        introTemp.card_content[index].content_ru = event.target.value;
      else if (guideContentLang[index] === 8)
        introTemp.card_content[index].content_de = event.target.value;
    }

    setHotelInfo({ ...introTemp });
  };

  // const onChange_voucherComment = (event: any) => {
  //   let introTemp = voucherData;
  //   if (voucherCommentLang === 0) introTemp.comment = event.target.value;
  //   else if (voucherCommentLang === 1) introTemp.comment_en = event.target.value;
  //   else if (voucherCommentLang === 2) introTemp.comment_ch = event.target.value;
  //   else if (voucherCommentLang === 3) introTemp.comment_ja = event.target.value;
  //   else if (voucherCommentLang === 4) introTemp.comment_th = event.target.value;
  //   else if (voucherCommentLang === 5) introTemp.comment_es = event.target.value;
  //   else if (voucherCommentLang === 6) introTemp.comment_fr = event.target.value;
  //   else if (voucherCommentLang === 7) introTemp.comment_ru = event.target.value;
  //   else if (voucherCommentLang === 8) introTemp.comment_de = event.target.value;

  //   setVoucherData({ ...introTemp });
  // };
  const onChange_store_name = (event: any) => {
    let introTemp = voucherData;
    introTemp.store_name = event.target.value;
    setVoucherData({ ...introTemp });
  };
  const onChange_store_name_en = (event: any) => {
    let introTemp = voucherData;
    introTemp.store_name_en = event.target.value;
    setVoucherData({ ...introTemp });
  };
  const onChange_benefit = (event: any) => {
    let introTemp = voucherData;
    introTemp.benefit = event.target.value;
    setVoucherData({ ...introTemp });
  };
  const onChange_benefit_en = (event: any) => {
    let introTemp = voucherData;
    introTemp.benefit_en = event.target.value;
    setVoucherData({ ...introTemp });
  };
  const onChange_address = (event: any) => {
    let introTemp = voucherData;
    introTemp.address = event.target.value;
    setVoucherData({ ...introTemp });
  };
  const onChange_address_en = (event: any) => {
    let introTemp = voucherData;
    introTemp.address_en = event.target.value;
    setVoucherData({ ...introTemp });
  };
  const onChange_phone_number = (event: any) => {
    let introTemp = voucherData;
    introTemp.phone_number = event.target.value;
    setVoucherData({ ...introTemp });
  };
  const onChange_map_link = (event: any) => {
    let introTemp = voucherData;
    introTemp.map_link = event.target.value;
    setVoucherData({ ...introTemp });
  };
  const onChange_voucherComment = (event: any) => {
    let introTemp = voucherData;
    introTemp.comment = event.target.value;
    setVoucherData({ ...introTemp });
  };

  const onChange_guideNameLang = (value: number) => {
    setGuideTitleLang(value);
  };

  const onChange_guideInfoLang = (index: number, value: number) => {
    let guideInfoLangTemp = guideContentLang;
    guideInfoLangTemp[index] = value;
    setGuideContentLang([...guideInfoLangTemp]);
  };

  const onChange_commentLang = (value: number) => {
    if (isVoucher) {
      setVoucherCommentLang(value);
    }
  };

  // 필수 확인
  const checkRequired = () => {
    if (
      hotelInfo.title !== null &&
      hotelInfo.title.length > 0 &&
      hotelInfo.url !== null &&
      hotelInfo.card_content.length > 0
    ) {
      if (
        isVoucher &&
        voucherData.map_link &&
        voucherData.map_link.length > 0 &&
        voucherData.phone_number &&
        voucherData.phone_number.length > 0 &&
        voucherData.store_name &&
        voucherData.store_name_en.length > 0 &&
        voucherData.address &&
        voucherData.address.length > 0 &&
        voucherData.address_en &&
        voucherData.address_en.length > 0 &&
        voucherData.store_name &&
        voucherData.store_name_en.length > 0 &&
        voucherData.benefit &&
        voucherData.benefit_en.length > 0 &&
        voucherData.comment &&
        voucherData.comment.length > 0
      ) {
        return true;
      } else if (!isVoucher) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  };

  const deleteLogoImage = () => {
    let introTemp = hotelInfo;
    introTemp.url = null;
    setHotelInfo({ ...introTemp });
  };

  // const deleteImage = (mainIndex: number, itemIndex: number) => {
  //   guideContents[mainIndex].guide_img.splice(itemIndex, 1);
  //   setGuideContents([...guideContents]);
  // };

  useEffect(() => {
    if (card_id && card_id !== '-1') {
      getHotelIntroCard();
    }
  }, [card_id]);

  return (
    <>
      <Style>
        <div className="contentContainer">
          <div className="editHeaderWrap">
            <button className="backButton" onClick={() => navigate(-1)}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_arrow_left.svg`} alt="ic" />
            </button>
            {card_id && card_id !== '-1' && (
              <button className="deleteButton" onClick={() => setVisibleConfirm(true)}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_trashcan_green.svg`} alt="ic" />
                <h5>소개삭제</h5>
              </button>
            )}
          </div>
          <div className="inputText">
            <div className="title initial">
              <h4>제목</h4>
              <h5 className="greenFont">(필수)</h5>
            </div>
            <div className="infoRow">
              <div>
                <button
                  className={`langButton ${guideTitleLang === 0 && 'active'}`}
                  onClick={() => onChange_guideNameLang(0)}>
                  한국어
                </button>
                <button
                  className={`langButton ${guideTitleLang === 1 && 'active'}`}
                  onClick={() => onChange_guideNameLang(1)}>
                  영어
                </button>
                <button
                  className={`langButton ${guideTitleLang === 2 && 'active'}`}
                  onClick={() => onChange_guideNameLang(2)}>
                  중국어
                </button>
                <button
                  className={`langButton ${guideTitleLang === 3 && 'active'}`}
                  onClick={() => onChange_guideNameLang(3)}>
                  일본어
                </button>
                <button
                  className={`langButton ${guideTitleLang === 4 && 'active'}`}
                  onClick={() => onChange_guideNameLang(4)}>
                  태국어
                </button>
                <button
                  className={`langButton ${guideTitleLang === 5 && 'active'}`}
                  onClick={() => onChange_guideNameLang(5)}>
                  스페인어
                </button>
                <button
                  className={`langButton ${guideTitleLang === 6 && 'active'}`}
                  onClick={() => onChange_guideNameLang(6)}>
                  프랑스어
                </button>
                <button
                  className={`langButton ${guideTitleLang === 7 && 'active'}`}
                  onClick={() => onChange_guideNameLang(7)}>
                  러시아어
                </button>
                <button
                  className={`langButton ${guideTitleLang === 8 && 'active'}`}
                  onClick={() => onChange_guideNameLang(8)}>
                  독일어
                </button>
              </div>
              <textarea
                placeholder="제목을 입력해주세요.  예) 호텔 소개, 이벤트 등록"
                value={getLangToTitle()!}
                onChange={onChange_guideName}
                autoFocus={true}
              />
            </div>
          </div>

          <div className="inputText">
            <div className="title guide">
              <h4>로고 이미지</h4>
              <h5 className="greenFont">(필수)</h5>
              <h5 className="greyFont">권장사이즈: 800 x 680</h5>
            </div>
            <div className="imageList logo">
              <input
                id="logoImage"
                type="file"
                name="photo"
                accept="image/*"
                autoFocus={false}
                onChange={uploadLogoImage}
              />
              {hotelInfo.url !== null && hotelInfo.url !== '' ? (
                <div className="previewImageWrap logo">
                  <img className="previewImg" src={hotelInfo.url} alt="img" />
                </div>
              ) : (
                <label className="photoBox logo" htmlFor="logoImage">
                  <img src={`${process.env.PUBLIC_URL}/svg/ic_photo.svg`} alt="ic" />
                  <h5>이미지 추가</h5>
                </label>
              )}
              {hotelInfo.url !== null && hotelInfo.url && (
                <>
                  <label className="imageButton edit" htmlFor="logoImage">
                    수정
                  </label>
                  <button className="imageButton delete" onClick={deleteLogoImage}>
                    삭제
                  </button>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="contentContainer">
          <div className="inputText">
            <div className="title initial">
              <h4>이미지 및 설명</h4>
              <h5 className="greenFont">(필수)</h5>
            </div>
            <div className="warningSign">
              <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
              <p>등록하지 않은 언어는 한국어로 표시됩니다.</p>
            </div>

            <div className="imageWrap">
              <DndProvider backend={HTML5Backend}>
                {hotelInfo.card_content.map((item: HotelIntroCardType, index: number) => (
                  <RenderContentItem
                    key={index}
                    item={item}
                    index={index}
                    moveItem={moveItem}
                    uploadContentImage={uploadContentImage}
                    guideContentLang={guideContentLang}
                    onChange_guideInfoLang={onChange_guideInfoLang}
                    deleteContent={deleteContent}
                    getLangToContent={getLangToContent}
                    onChange_guideContent={onChange_guideContent}
                  />
                ))}
              </DndProvider>
            </div>
            <div className="row gap">
              {/* {hotelInfo.card_content.filter((item) => item.content_type === 1).length < 11 && ( */}
              <button className="addButton" onClick={() => addStoreInfo(0)}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="ic" />
                <h5>사진 추가하기</h5>
              </button>
              {/* )}
               {hotelInfo.card_content.filter((item) => item.content_type === 1).length < 11 && ( */}
              <button className="addButton" onClick={() => addStoreInfo(1)}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="ic" />
                <h5>글 추가하기</h5>
              </button>
              {/*)}*/}
            </div>
          </div>
        </div>
        <div className="contentContainer">
          <div className="inputText">
            <label className="checkbox">
              <div className="title initial">
                <h4>바우처 등록 여부</h4>
                <h5 className="greenFont">(필수)</h5>
              </div>
              <input
                id="isShow"
                type="checkbox"
                checked={isVoucher}
                onChange={() => setIsVoucher(!isVoucher)}
              />
            </label>
            <div className="title">
              <h4>매장 이름</h4>
              <h5 className="greenFont">(필수)</h5>
            </div>
            <div className={`infoRow ${!isVoucher && 'disabled'}`}>
              <input
                placeholder="바우처를 지급할 매장 이름을 입력해주세요."
                value={voucherData.store_name}
                onChange={onChange_store_name}
                autoFocus={false}
                disabled={!isVoucher}
              />
            </div>
            <div className="title sector">
              <h4>매장 이름 (영문)</h4>
              <h5 className="greenFont">(필수)</h5>
            </div>
            <div className={`infoRow ${!isVoucher && 'disabled'}`}>
              <input
                placeholder="바우처를 지급할 매장 이름의 영문을 입력해주세요."
                value={voucherData.store_name_en}
                onChange={onChange_store_name_en}
                autoFocus={false}
                disabled={!isVoucher}
              />
            </div>
            <div className="title">
              <h4>혜택</h4>
              <h5 className="greenFont">(필수)</h5>
            </div>
            <div className={`infoRow ${!isVoucher && 'disabled'}`}>
              <input
                placeholder="바우처 지급 혜택을 입력해주세요."
                value={voucherData.benefit}
                onChange={onChange_benefit}
                autoFocus={false}
                disabled={!isVoucher}
              />
            </div>
            <div className="title sector">
              <h4>혜택 (영문)</h4>
              <h5 className="greenFont">(필수)</h5>
            </div>
            <div className={`infoRow ${!isVoucher && 'disabled'}`}>
              <input
                placeholder="바우처 지급 혜택의 영문을 입력해주세요."
                value={voucherData.benefit_en}
                onChange={onChange_benefit_en}
                autoFocus={false}
                disabled={!isVoucher}
              />
            </div>
            <div className="title">
              <h4>주소</h4>
              <h5 className="greenFont">(필수)</h5>
            </div>
            <div className={`infoRow ${!isVoucher && 'disabled'}`}>
              <input
                placeholder="주소를 입력해주세요."
                value={voucherData.address}
                onChange={onChange_address}
                autoFocus={false}
                disabled={!isVoucher}
              />
            </div>
            <div className="title sector">
              <h4>주소 (영문)</h4>
              <h5 className="greenFont">(필수)</h5>
            </div>
            <div className={`infoRow ${!isVoucher && 'disabled'}`}>
              <input
                placeholder="영문 주소를 입력해주세요."
                value={voucherData.address_en}
                onChange={onChange_address_en}
                autoFocus={false}
                disabled={!isVoucher}
              />
            </div>
            <div className="title">
              <h4>전화번호</h4>
              <h5 className="greenFont">(필수)</h5>
            </div>
            <div className={`infoRow ${!isVoucher && 'disabled'}`}>
              <input
                placeholder="전화번호를 입력해주세요."
                value={voucherData.phone_number}
                onChange={onChange_phone_number}
                autoFocus={false}
                disabled={!isVoucher}
              />
            </div>
            <div className="title">
              <h4>url 링크</h4>
              <h5 className="greenFont">(필수)</h5>
            </div>
            <div className={`infoRow ${!isVoucher && 'disabled'}`}>
              <input
                placeholder="연결할 url 링크를 입력해주세요."
                value={voucherData.map_link}
                onChange={onChange_map_link}
                autoFocus={false}
                disabled={!isVoucher}
              />
            </div>
            <div className="title">
              <h4>만료일자</h4>
              <h5 className="greenFont">(필수)</h5>
            </div>
            <label className="checkbox">
              <h4 className="checkbox">무기한 등록 여부</h4>
              <input
                id="isEndDateInfinite"
                type="checkbox"
                checked={isEndDateInfinite}
                onChange={() => setIsEndDateInfinite(!isEndDateInfinite)}
                disabled={!isVoucher}
              />
            </label>
            <div className="calendarWrap">
              <DatePicker
                id="endDate"
                dateFormat="yyyy-MM-dd"
                isClearable={false}
                locale="ko"
                selected={endDate}
                onChange={(e: any) => setEndDate(e)}
                minDate={endDate}
                disabledKeyboardNavigation={true}
                onFocus={(e) => {
                  e.preventDefault();
                  e.target.blur();
                }}
                disabled={isEndDateInfinite || !isVoucher}
              />
              <label
                className={`datePicker ${(isEndDateInfinite || !isVoucher) && 'disabled'}`}
                htmlFor="endDate">
                {moment(endDate).format('YYYY / MM / DD')}
                <img
                  className="calendar"
                  src={`${process.env.PUBLIC_URL}/svg/ic_calendar.svg`}
                  alt="달력아이콘"
                />
              </label>
            </div>

            <div className="title">
              <h4>바우처 설명</h4>
              <h5 className="greenFont">(필수)</h5>
            </div>
            <div className={`infoRow ${!isVoucher && 'disabled'}`}>
              {/* <div>
                <button
                  className={`langButton ${voucherCommentLang === 0 && 'active'}`}
                  onClick={() => onChange_commentLang(0)}>
                  한국어
                </button>
                <button
                  className={`langButton ${voucherCommentLang === 1 && 'active'}`}
                  onClick={() => onChange_commentLang(1)}>
                  영어
                </button>
                <button
                  className={`langButton ${voucherCommentLang === 2 && 'active'}`}
                  onClick={() => onChange_commentLang(2)}>
                  중국어
                </button>
                <button
                  className={`langButton ${voucherCommentLang === 3 && 'active'}`}
                  onClick={() => onChange_commentLang(3)}>
                  일본어
                </button>
                <button
                  className={`langButton ${voucherCommentLang === 4 && 'active'}`}
                  onClick={() => onChange_commentLang(4)}>
                  태국어
                </button>
                <button
                  className={`langButton ${voucherCommentLang === 5 && 'active'}`}
                  onClick={() => onChange_commentLang(5)}>
                  스페인어
                </button>
                <button
                  className={`langButton ${voucherCommentLang === 6 && 'active'}`}
                  onClick={() => onChange_commentLang(6)}>
                  프랑스어
                </button>
                <button
                  className={`langButton ${voucherCommentLang === 7 && 'active'}`}
                  onClick={() => onChange_commentLang(7)}>
                  러시아어
                </button>
                <button
                  className={`langButton ${voucherCommentLang === 8 && 'active'}`}
                  onClick={() => onChange_commentLang(8)}>
                  독일어
                </button>
              </div> */}
              <input
                placeholder="바우처 설명을 입력해주세요."
                value={getLangToComment()!}
                onChange={onChange_voucherComment}
                autoFocus={false}
                disabled={!isVoucher}
              />
            </div>
          </div>
          <button
            className={`submitButton ${!checkRequired() && 'inactive'}`}
            onClick={card_id && card_id !== '-1' ? editHotelIntro : setHotelIntro}>
            매장정보 등록
          </button>
        </div>
      </Style>
      <ConfirmModal
        isOpen={visibleConfirm}
        title={`삭제 후 복구할 수 없습니다.\n정말 삭제하시겠어요?`}
        onCancelText="취소"
        onConfirmText="삭제"
        onCancel={() => setVisibleConfirm(false)}
        onConfirm={delHotelIntro}
      />
    </>
  );
};

export default RecommendEdit;

const Style = styled.div`
  .contentContainer:nth-child(1) {
    border-radius: 10px 10px 0 0;
  }
  .contentContainer:nth-child(2) {
    border-radius: 0 0 10px 10px;
  }

  .editHeaderWrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;

    .backButton {
      margin-left: -16px;
    }

    .deleteButton {
      display: flex;
      align-items: center;
      padding: 6px 10px;
      border: 1px solid #40977f;
      background: #fff;
      border-radius: 5px;
      gap: 10px;
      h5 {
        color: #40977f;
      }
    }
  }

  .inputText {
    img {
      cursor: pointer;
    }

    h4.checkbox {
      font-size: 14px;
      font-weight: 500;
      color: #555555;
      padding: 0;
    }

    .title {
      padding: 30px 0 6px 0;
      display: flex;
      align-items: center;
      gap: 4px;

      h5 {
        color: #ff7e7e;
        font-weight: 500;
      }
      .greenFont {
        color: #40977f;
      }
      .greyFont {
        color: #979797;
        font-weight: 400;
      }
      h4 {
        color: #555555;
      }
    }
    .title.initial {
      padding: 0 0 6px 0;
    }
    .title.sector {
      padding: 10px 0 6px 0;
    }

    .langButton {
      width: 80px;
      padding: 10px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      border: 1px solid #cecece;
      border-radius: 5px 0 0 5px;
      font-size: 16px;
      line-height: 24px;
      margin-right: -1px;
      color: #a7a7a7;
    }
    .langButton.active {
      background: #ecf5f3;
      border: 1px solid #4dd2ae;
      color: #4dd2ae;
      z-index: 1;
    }

    input::placeholder,
    textarea::placeholder {
      color: #a7a7a7;
    }

    .infoRow {
      display: flex;
    }

    input {
      width: 100%;
      padding: 10px 16px;
      border: 1px solid #cecece;
      border-radius: 5px;
      color: #555555;
    }

    textarea {
      width: 100%;
      padding: 28px 16px;
      border: 1px solid #cecece;
      border-radius: 0 5px 5px 0;
      color: #555555;
    }

    .infoRow.disabled {
      input,
      textarea {
        cursor: not-allowed;
      }
      .langButton {
        filter: brightness(0.9);
        cursor: not-allowed;
      }
    }
  }

  input.point {
    width: 30px;
    height: 30px;
    padding: 4px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
    text-align: center;
    color: #4dd2ae;
    background: #ffffff;
    border: 1px solid #4dd2ae;
    border-radius: 4px;
    margin-bottom: 10px;
  }

  .infoBadge {
    background: #ecf5f3;
    border-radius: 5px;
    display: flex;
    align-items: center;
    padding: 8px 20px;
    gap: 6px;
    h4 {
      color: #555555;
    }
  }

  /* 주소검색 */
  .address {
    position: relative;

    .searchBox {
      margin-bottom: 8px;
      position: absolute;
      top: 0;
      bottom: 0;
      padding: 10px 20px;
      border: none;
      background: #4dd2ae;
      color: #fff;
      border-radius: 5px;
      cursor: pointer;
      font-size: 16px;
      font-weight: 700;
      display: flex;
      align-items: center;
      right: 0%;
    }
  }

  .warningSign {
    padding-bottom: 20px;
  }

  .storeInfoWrap {
    position: relative;
    margin-bottom: 20px;

    .imageWrap {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .imageButton {
        margin-bottom: 10px;
      }
    }
  }

  .addButton {
    width: 100%;
    background: #fff;
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    padding: 8px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5%;
    margin-bottom: 10px;

    h5 {
      font-weight: 600;
      color: #4dd2ae;
      white-space: nowrap;
      padding: 0;
    }
  }

  .imageButton {
    background: #ffffff;
    text-align: center;
    border-radius: 5px;
    padding: 6px 14px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    white-space: nowrap;
    cursor: pointer;
  }
  .imageButton.edit {
    border: 1px solid #cecece;
    color: #555555;
  }
  .imageButton.delete {
    border: 1px solid #4dd2ae;
    color: #4dd2ae;
  }
  .imageButton.delete.bottom {
    margin-top: 10px;
  }

  .imageList {
    display: flex;
    align-items: center;
    gap: 8px;
    overflow-x: auto;
    padding-bottom: 20px;
    flex-wrap: wrap;

    .row.between {
      align-items: flex-start;
    }

    .previewImageWrap {
      width: 120px;
      height: 120px;
      position: relative;
    }
    .previewImageWrap.logo {
      width: 140px;
    }

    .previewImg {
      width: 100%;
      height: 100%;
      border-radius: 5px;
      object-fit: cover;
    }
    .previweImg.logo {
      height: 102px;
    }

    .photoBox {
      position: relative;
      width: 120px;
      height: 120px;
      border-radius: 5px;
      padding: 10px;
      padding-top: 20px;
      border: 1px solid #cecece;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 6px;
      cursor: pointer;

      h5 {
        color: #a7a7a7;
        font-weight: 400;
      }
    }
    .photoBox.logo {
      width: 140px;
    }
  }
  .imageList.logo {
    align-items: flex-end;
  }

  .row.gap {
    gap: 8px;
  }

  .imageDeleteButton {
    position: absolute;
    top: 0;
    right: 0;
    width: 24px;
    height: 24px;
    border-radius: 0 5px 0 5px;
    background: rgba(0, 0, 0, 0.3);
  }

  input[type='file'] {
    display: none;
  }

  .submitButton {
    width: 100%;
    margin-top: 50px;
    padding: 12px 0;
    background: #4dd2ae;
    color: #fff;
    border: none;
    outline: none;
    border-radius: 8px;
    font-size: 20px;
    line-height: 28px;
    font-weight: 700;
  }

  .submitButton.inactive {
    background: #cecece;
  }

  .warningSign {
    padding: 4px 0;
    display: flex;
    align-items: flex-start;
    gap: 6px;

    p {
      font-size: 14px;
      line-height: 16px;
      color: #979797;
    }
    span {
      font-size: 12px;
      color: #979797;
      font-weight: 400;
    }
  }

  label.checkbox {
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 8px;
    input[type='checkbox'] {
      accent-color: #40977f;
      width: 22px;
      height: 22px;
      vertical-align: middle;
    }
  }

  .calendarRow {
    display: flex;
    gap: 6px;
    align-items: center;
    h5 {
      color: #555555;
      font-weight: 500;
      margin-top: -20px;
    }
  }

  .calendarWrap {
    flex: 1;
    display: flex;
    align-items: center;
    position: relative;
    margin-top: 10px;

    input {
      display: none;
    }
    .calendar {
      position: absolute;
      right: 12px;
      top: 8px;
      height: 18px;
    }
  }
  .datePicker {
    padding: 9px;
    font-size: 12px;
    line-height: 16px;
  }

  .datePicker {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 9px 20px;
    border-radius: 5px;
    border: 1px solid #cecece;
    color: #a7a7a7;
    font-weight: 400;
    font-size: 16px;
    cursor: pointer;
    letter-spacing: 0.5px;

    input {
      display: none;
    }
  }
  .datePicker.disabled {
    background: #efefef4d;
    cursor: default;
  }

  @media (max-width: 800px) {
    .contentContainer {
      width: 100%;
      margin: 0 auto;
      padding: 4%;
      background: #ffffff;
      border-radius: 10px;
    }

    .inputText {
      .langButton {
        width: 60px;
        padding: 6px 0;
        font-size: 12px;
        line-height: 20px;
      }

      input {
        padding: 8px 16px;
        font-size: 14px;
      }
      textarea {
        padding: 16px;
        font-size: 14px;
      }
    }
  }

  /* 전체 */
  .react-datepicker {
    display: flex;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25) !important;
    border-radius: 10px !important;
    border: 1px solid #4dd2ae !important;
  }

  /* 헤더 */
  .react-datepicker__header {
    background: #ecf5f3 !important;
    border-bottom: 1px solid #4dd2ae !important;
    border-radius: 10px 10px 0 0 !important;
  }
  /* 현재연월 */
  .react-datepicker__current-month {
    color: #40977f;
  }
  /* 요일 */
  .react-datepicker__day-name {
    width: 28px;
    color: #40977f;
    font-weight: 500;
  }
  /* 일요일 */
  .react-datepicker__day-name:nth-child(1) {
    color: #ff7e7e;
  }
  /* 토요일 */
  .react-datepicker__day-name:nth-child(7) {
    color: #67a4ff;
  }

  /* 날짜 */
  .react-datepicker__day {
    width: 28px;
    height: 28px;
    border-radius: 5px;
    font-weight: 400;
  }
  /* 선택불가 */
  .react-datepicker__day--disabled {
    color: #cecece !important;
    pointer-events: none;
  }

  /* 일요일 */
  .react-datepicker__day:nth-child(1) {
    color: #ff7e7e;
  }
  /* 토요일 */
  .react-datepicker__day:nth-child(7) {
    color: #67a4ff;
  }

  /* 범위 */
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range {
    background: #ecf5f3 !important;
    border: 1px solid #4dd2ae;
    color: #40977f !important;
  }
  /* 현재 */
  .react-datepicker__day--today {
    border: 1px solid #4dd2ae !important;
    color: #40977f;
    background: #ffffff;
  }
  /* 헤더 */
  .react-datepicker__header {
    background: #ecf5f3;
    border-bottom: 1px solid #4dd2ae;
    border-radius: 10px 10px 0 0;
  }
  /* 현재연월 */
  .react-datepicker__current-month {
    color: #40977f;
  }
  /* 요일 */
  .react-datepicker__day-name {
    width: 28px;
    color: #40977f;
    font-weight: 500;
  }
  /* 일요일 */
  .react-datepicker__day-name:nth-child(1) {
    color: #ff7e7e;
  }
  /* 토요일 */
  .react-datepicker__day-name:nth-child(7) {
    color: #67a4ff;
  }

  /* 말꼬리 */
  .react-datepicker__triangle {
    display: none;
  }
  /* 위치 */
  .react-datepicker-popper {
    padding: 10px 0 0 0;
  }

  /* outside */
  .react-datepicker__day--outside-month {
    background: #fff !important;
    border: none;
  }
  .react-datepicker__week {
    display: flex;
    align-items: center;
  }
  /* 범위 시작일 */
  .react-datepicker__day--range-start {
    background: #4dd2ae !important;
    border: 1px solid #4dd2ae !important;
    color: #ffffff !important;
    font-weight: 500;
  }
  /* 범위 종료일 */
  .react-datepicker__day--range-end {
    background: #4dd2ae !important;
    border: 1px solid #4dd2ae !important;
    color: #ffffff !important;
    font-weight: 500;
  }
  /* 선택한 날짜 */
  .react-datepicker__day--selected {
    background: #4dd2ae !important;
    border: 1px solid #4dd2ae !important;
    color: #ffffff !important;
    font-weight: 600;
  }
`;
